import { render, staticRenderFns } from "./InvestorReport.vue?vue&type=template&id=63fa485a&"
import script from "./InvestorReport.vue?vue&type=script&lang=js&"
export * from "./InvestorReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports